export const typographyUtilityClasses = typography => {
    const tag = typography?.visual?.split('-').slice(0, -1).join('-') || 'paragraph';
    const modifier = typography?.visual?.split('-').slice(-1).join('-') || 'regular';

    return [
        `u-${tag}`,
        `u-${modifier}`,
    ];
};
